import gql from 'graphql-tag';

export const GET_REVIEWS = gql`
  query($regionUrl: String!, $offset: Int!, $limit: Int!) {
    landingReviews(regionUrl: $regionUrl, offset: $offset, limit: $limit) {
      reviewsCount
      reviewsList {
        rentDate
        guestType
        guestAvatar
        guestCountry
        guestName
        review
      }
    }
  }
`;
